/**
 * @contract
 *   Назначение: ТИПЫ + хелперы каталога учебных центров (школ охраны) — DB-backed.
 *   Маршрут:   /tools/uchebne-centry
 *   Источник:  public.schools (миграция 20260824000006)
 *   Семантика: license_to — срок лицензии Росгвардии;
 *              license_status/number/authority — лицензия Рособрнадзора ISLOD.
 */

/** Строка каталога школ (public.schools, snake_case как отдаёт PostgREST). */
export interface SchoolCard {
  id: string;
  inn: string;
  name_full: string;
  name_short: string | null;
  region: string | null;
  city: string | null;
  address: string | null;
  license_to: string | null; // YYYY-MM-DD (Росгвардия; null = бессрочная)
  license_status: string | null; // active|revoked|... (Рособрнадзор ISLOD)
  license_number: string | null; // рег. номер Л035-...
  license_authority: string | null; // орган, выдавший лицензию ISLOD
  license_checked_at: string | null; // дата ETL-среза ISLOD
  only_4th_rank: boolean; // «только по 4 разряду»
  website: string | null;
  ogrn: string | null;
  registered_at: string | null;
  kpp: string | null;
  social_links: { kind: string; value: string }[] | null;
  employees: number | null;
  director: string | null;
  founders: { type: string; name: string; inn?: string }[] | null;
}

/** Уникальные регионы (сортировка по количеству школ) для селекта. */
export function getRegions(schools: SchoolCard[]): { name: string; count: number }[] {
  const map = new Map<string, number>();
  for (const s of schools) {
    const r = s.region?.trim() ?? "";
    if (!r) continue;
    map.set(r, (map.get(r) ?? 0) + 1);
  }
  return Array.from(map.entries())
    .map(([name, count]) => ({ name, count }))
    .sort((a, b) => b.count - a.count);
}

/** Поиск школ по названию/городу/региону/ИНН (регистронезависимо). */
export function searchSchools(schools: SchoolCard[], query: string): SchoolCard[] {
  const q = query.trim().toLowerCase();
  if (!q) return schools;
  return schools.filter(
    (s) =>
      s.name_full.toLowerCase().includes(q) ||
      (s.city ?? "").toLowerCase().includes(q) ||
      (s.region ?? "").toLowerCase().includes(q) ||
      s.inn.includes(q)
  );
}

/** Признак «лицензия Рособрнадзора опасна» (отозвана/неактивна) для UI-бейджа. */
export function isLicenseDanger(school: SchoolCard): boolean {
  // owner-готча: не матчить label (startsWith('Срок') всегда false) — по флагу
  return (school.license_status ?? "").toLowerCase() === "revoked" ||
         (school.license_status ?? "").toLowerCase() === "none";
}
